import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_SEARCH } from '../../../RequestProfileTabEmails.constants'

export function getRequestProfileTabEmailsSearchFilters(searchQuery) {
  return searchQuery.length > 0
    ? { [REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_SEARCH]: searchQuery }
    : EMPTY_OBJECT
}
